// extracted by mini-css-extract-plugin
module.exports = {"boxes_exercise__container":"BoxesExercise-module--boxes_exercise__container--3Zwbz"};